import { render, staticRenderFns } from "./AddOfferModal.vue?vue&type=template&id=488ec6fd&scoped=true&"
import script from "./AddOfferModal.vue?vue&type=script&lang=js&"
export * from "./AddOfferModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOfferModal.vue?vue&type=style&index=0&id=488ec6fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ec6fd",
  null
  
)

export default component.exports